export enum OnboardingDataLayerEvent {
    // SessionEvents
    FunnelOpen = "funnelOpen",
    Error = "error",

    // Search by AddressLookup
    AddressLookupFormSent = "aLookupFormSent",
    AddressLookupPRMmeterFound = "aLookupPRMmeterFound",
    AddressLookupPCEmeterFound = "aLookupPCEmeterFound",
    AddressLookupPRMmeterNotFound = "aLookupPRMmeterNotFound",
    AddressLookupPCEmeterNotFound = "aLookupPCEmeterNotFound",
    AddressLookupAllMeterFound = "aLookupAllMeterFound",

    // Search by InvoiceUpload
    InvoiceUploadFormSent = "invoiceUploadFormSent",

    // Search by Meter
    MeterPointsSent = "meterPointsSent",

    // MeterConfirmationEvents
    MeterConfirmationAll = "allMeterConfirmation",

    // ProviderCalendarEvents
    ProviderCalendarRequest = "tariffOptionRequest",
    ProviderCalendarSubmitted = "tariffOptionSubmitted",

    // MeterReadingEvents
    MeterReadingRequest = "meterReadingRequest",
    MeterReadingSubmitted = "meterReadingSubmitted",

    // EnergyLandscapeEvents
    EnergyLandscapeRequest = "energyLandscapeRequest",
    EnergyLandscapeSubmitted = "energyLandscapeSubmitted",

    // QuoteEvents
    QuoteGenerated = "quoteGenerated",
    QuoteValidated = "quoteValidated",
    DraftQuote = "draftQuote",

    // PersonalInfoEvents
    PersonalInfoRequest = "personalInfoRequest",
    PersonalInfoSubmitted = "personalInfoSubmitted",

    // PaymentInfoEvents
    PaymentInfoRequest = "paymentInfoRequest",
    PaymentInfoSubmitted = "paymentInfoSubmitted",

    // OrderSummaryEvents
    OrderSummaryValidated = "orderSummaryValidated",
    OrderSummaryViewed = "orderSummaryViewed",
    OrderSummarySuccess = "orderSummarySuccess",

    // OctoshieldEvents
    OctoshieldBlocked = "octoshieldBlocked",

    // PrepaymentEvents
    MeeloEvent = "meeloEvent",
    PrepaymentRequested = "prepaymentRequested",

    PrepaymentError = "prepaymentError",
    PrepaymentFailed = "prepaymentFailed",
    PrepaymentCancelled = "prepaymentCancelled",
    PrepaymentExpired = "prepaymentExpired",
    PrepaymentPending = "prepaymentPending",
    PrepaymentSuccess = "prepaymentSuccess",
    MandateSubmitted = "mandateSubmitted",

    // SubscriptionEvents
    SubscriptionCompleted = "subscriptionCompleted",

    // ChatbotEvents
    ChatbotIconDisplayed = "chatbot_icon_displayed",
    ChatbotOpened = "chatbot_opened",
    ChatbotQuestionClicked = "chatbot_question_clicked",
    ChatbotFreeTextSubmitted = "chatbot_free_text_submitted",
    ChatbotCustomerServiceClicked = "chatbot_customer_service_clicked",
    ChatbotClosed = "chatbot_closed",
}
